<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="策略名称:">
                        <el-input
                            placeholder="请填写策略名称"
                            v-model="formData.name"
                            show-word-limit
                            maxlength="40"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="tips" label="付费提示:">
                        <el-input
                            placeholder="请填写付费提示"
                            v-model="formData.tips"
                            show-word-limit
                            maxlength="100"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="activityId" label="收费对象:">
                        <el-input v-model="formData.activityId" 
                            maxlength="10" 
                            class="input-with-select" 
                            @input="onInput"
                            placeholder="请填写ID" 
                            size="medium">
                            <el-select
                                v-model="formData.type"
                                slot="prepend"
                                placeholder="请选择"
                            >
                                <el-option label="演出" :value="1"></el-option>
                                <el-option label="众筹" :value="2"></el-option>
                                <el-option label="周边" :value="3"></el-option>
                            </el-select>
                            <el-button slot="append" :loading="jumpLoading" @click="verifyJump">解析</el-button>
                        </el-input>
                        <el-alert v-if="jumpText" :title="jumpText" type="success" :closable="false"></el-alert>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="freeUserIdStr" label="免费观看用户:">
                        <el-input
                            type="textarea"
                            placeholder="请填写免费观看用户"
                            v-model="formData.freeUserIdStr"
                            show-word-limit
                            rows="8"
                            maxlength="1000"
                            size="medium"
                        ></el-input>
                        <small class="MT10">
                            <span class="el-icon-warning"></span>  
                            填写用户ID，多个ID之间用逗号分隔
                        </small>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="videoValue" label="绑定视频:">
                        <el-input v-model="videoValue" 
                            maxlength="10" 
                            class="input-with-select" 
                            placeholder="请填视频ID进行查找" 
                            @input="videoInput"
                            size="medium">
                            <el-button slot="append" :loading="fetchLoading" @click="remoteMethod">添加</el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="videoValue" label="绑定视频:">
                        <el-input v-model="videoValue" 
                            maxlength="10" 
                            class="input-with-select" 
                            placeholder="请填视频ID进行查找" 
                            @input="videoInput"
                            size="medium">
                            <el-button slot="append" :loading="fetchLoading" @click="remoteMethod">添加</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="bindVideos" label="视频列表:">
                        <el-table
                            :data="formData.bindVideos"
                            border
                            style="width: 100%"
                            v-loading="fetchLoading"
                            size="small"
                            stripe>
                            <el-table-column label="操作" width="60">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="del(scope.$index)">解绑</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" label="视频ID"></el-table-column>
                            <el-table-column prop="name" label="视频名称" min-width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="time" label="时长"></el-table-column>
                            <el-table-column prop="freeTime" label="免费观看时长（秒）" min-width="120">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.freeTime" @input="(value) => {if (!/^[0-9]+$/.test(value)) scope.row.freeTime = 10}" min="1" max="99999999" maxlength="8" placeholder="观看时长"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
                 <el-button @click="$router.go(-1)">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            id: this.$route.params.id, 
            formData: {
                type: 1,
                activityId: '',
                freeUserIdStr: '',
                name: '',
                tips: '',
                bindVideos: []
            },
            rules: {
                type: [{ required: true, message: "请填写名称" }],
                activityId: [{ required: true, message: "请填写解析ID" }],
                name: [{ required: true, message: "请填写策略名称" }],
                tips: [{ required: true, message: "请填写付费提示" }],
                bindVideos: [{ required: true, type: 'array', min: 1, message: "请为付费策略绑定至少一个视频" }],
            },
            videoValue: '',
            vdeoOptions: [],
            jumpText: '',
            tableData: [],
            fetchLoading: false,
            jumpLoading: false,
            selectLoading: false,
            btnLoading: false,
            pageLoading: false,
            verifyJumpNum: ''
        };
    },
    mounted() {
        if (this.id) this.getDetail();
    },
    methods: {
        async remoteMethod () {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/paid/search",
                method: "POST",
                params: { id: this.videoValue },
            });
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.formData.bindVideos.unshift({...result, ...{freeTime: 10, id: this.videoValue}});
        },
        //  验证跳转值
        async verifyJump () {
            if(!this.formData.activityId) return this.$message.error('请填写需要验证的ID');
            this.jumpLoading = true;
            this.jumpText = '';
            const response = await this.$request({
                url: "/paid/resolve",
                method: "POST",
                data: { type: this.formData.type, activityId: this.formData.activityId },
            });
            const {state, msg, result} = response.data;
            this.jumpLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.jumpText = result.name;
            this.verifyJumpNum = this.formData.activityId;
        },
        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/paid/info",
                method: "POST",
                params: { id: this.id },
            });
            const {msg, state, result} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.pageLoading = false;
            this.formData = {...this.formData, ...result};
            this.verifyJumpNum = result.activityId;
        },
        //表单提交
        onSubmit() {
            if(this.verifyJumpNum !== this.formData.activityId) return this.$message.error('请先解析跳转目标');
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const form = JSON.parse(JSON.stringify(this.formData));
                    const response = await this.$request({
                        url: '/paid/save',
                        method: "POST",
                        data: form,
                    });
                    const {msg, state} = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('策略保存成功');
                    this.$router.go(-1);
                }
            });
        },
        videoInput (value) {
            if (!/^[0-9]+$/.test(value)) this.videoValue = '';
        },
        onInput (value) {
            if (!/^[0-9]+$/.test(value)) this.formData.activityId = '';
        },
        //解除视频
        del(index){
            this.formData.bindVideos.splice(index, 1);
        }
    },
};
</script>

<style lang="scss" scoped>
.form-flex {
    display: flex;
    .el-checkbox {
        margin-left: 10px;
    }
}
.el-alert {
    padding: 0px 16px;
}
</style>